/**
 * API конфигурация
 * ЗАЧЕМ: Централизованное хранение API ключей и URL
 * Затрагивает: все запросы к Databento API
 */

// API ключ для Databento Connector
// Используется для всех запросов к /api/databento/*
export const DATABENTO_API_KEY = 'XoMSGltU1i5Co0eoO0LMYbDY8YM4_2WLYXrCUNxsdQU';

// Базовый URL для API запросов
// Все запросы идут напрямую на db.optioner.online (внешний сервер с данными Databento)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://db.optioner.online';

// WebSocket URL
// WebSocket подключается напрямую к db.optioner.online (внешний сервер с данными Databento)
export const WS_BASE_URL = process.env.REACT_APP_WS_URL || 'wss://db.optioner.online';

// Заголовки по умолчанию для Databento запросов
export const getDatabentoHeaders = () => ({
  'X-API-Key': DATABENTO_API_KEY,
  'Content-Type': 'application/json'
});
